import React from 'react';

import Testimonial from './Testimonial';
import { TestimonialFragmentFragment } from '../../__generated__/graphql';
import IconButton from '../../components/IconButton';
import Arrow from '../../components/icons/Arrow';
import Section from '../../layout/Section';
import SectionTitle from '../../layout/Section/SectionTitle';
import { ContentBlock } from '../types';

import style from './testimonials.module.css';

const Testimonials: ContentBlock<TestimonialFragmentFragment> = ({ fragment }) => {
  const [selectedIndex, setSelectedIndex] = React.useState(0);
  const [animateFromRight, setAnimateFromRight] = React.useState<boolean | null>(null);

  const contentBlockProps = fragment.testimonials;

  if (!contentBlockProps) {
    return null;
  }

  const handleClickNext = () => {
    setAnimateFromRight(true);
    const nextIndex = selectedIndex + 1;
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    setSelectedIndex(nextIndex % (contentBlockProps.testimonials?.length || 1));
  };

  const handleClickPrevious = () => {
    setAnimateFromRight(false);
    const previousIndex = selectedIndex - 1;
    setSelectedIndex(previousIndex < 0 ? (contentBlockProps.testimonials?.length ?? 0) - 1 : previousIndex);
  };

  // Use ||, as title could be an empty string
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  const shouldRenderHeader = contentBlockProps.title || (contentBlockProps.testimonials?.length ?? 0) > 1;

  return (
    <Section
      backgroundColor={contentBlockProps.darkBackground ? 'black' : 'white'}
      id={contentBlockProps.sectionId}
      innerContainerClassName={style.testimonials}
    >
      {shouldRenderHeader && (
        <div className={style.testimonialHeaderContainer}>
          {contentBlockProps.title && (
            <SectionTitle className={style.title}>
              {contentBlockProps.title}
            </SectionTitle>
          )}

          {(contentBlockProps.testimonials?.length ?? 0) > 1 && (
            <>
              <IconButton
                aria-label="Previous testimonial"
                onClick={handleClickPrevious}
              >
                <Arrow
                  direction="left"
                  iconColor="black"
                />
              </IconButton>

              <IconButton
                aria-label="Next testimonial"
                className={style.rightArrow}
                onClick={handleClickNext}
              >
                <Arrow
                  iconColor="black"
                />
              </IconButton>
            </>
          )}
        </div>
      )}

      <div className={style.testimonialsContainer}>
        {contentBlockProps.testimonials?.map((testimonial, index) => {
          if (testimonial?.author && testimonial.quote) {
            return (
              <Testimonial
                author={testimonial.author}
                authorImage={testimonial.authorImage}
                current={index === selectedIndex}
                key={`${testimonial.author}-${index.toString()}`}
                quote={testimonial.quote}
                transformFromRight={animateFromRight}
                withSectionTitleStyle={!shouldRenderHeader}
              />
            );
          }
        })}
      </div>
    </Section>
  );
};

export default Testimonials;
